export const storeMicrosites = {
  state: () => ({
    sizeView: null,
  }),

  mutations: {
    setSizeView(state, value) {
      state.sizeView = value
    },
  },

  actions: {
    setCurrentView({ commit }, value) {
      commit('setSizeView', value)
    },
  },
}
